import { diaryHomeResultsPath } from "@/features/diaries/routes";
import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy URL - redirects to the Results tab. */
export const Route = createFileRoute("/_app/diaries/$diaryId/home/progress")({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: diaryHomeResultsPath,
            params: { diaryId: params.diaryId },
        });
    },
});
